<template >
    <section class="content">
      <box title="Filtro">
        <div slot="body">
            <div class="row">
                <div class="col-md-8">
                    <input class="form-control" placeholder="Nome do produto ..." type="text" v-model="filter">
                </div>
                <div class="col-md-3">
                    <select class="form-control" v-model="cardapio" >
                        <option disabled >Selecione a Categoria</option>
                        <option value="todos">Todas</option>
                        <option v-for="c in categorias" v-bind:value="c.id">{{c.nome}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2" style="display: flex">
                    <router-link class="padding" to="/novo-produto" >
                      <button class="btn btn-primary" >Novo Produto</button>
                    </router-link>
                    <router-link class="padding" :to="{ name: 'orderProduto'}">
                      <button class="btn btn-success" >
                        <i class="fa fa-list-ol paddingRight"></i>Ordenar Produtos
                      </button>
                    </router-link>
                </div>
            </div>     
        </div>
      </box>       

       
      <box>
        <div slot="body">
          <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
          <div class="row">
              <div class="col-sm-6">
              <div id="example1_length" class="dataTables_length">

              </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-12 table-responsive" id="table">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                    <tr>
                        <th v-for="coluna in colunas">
                            <a href="javascript:;" @click="orderProduto(coluna)" >{{coluna | ucwords}}</a>
                        </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="p in productsFiltered">
                      <td>{{p.id}}</td>
                      <td class="sorting_1">{{p.nome}}</td>
                      <td>{{p.descricao}}</td>
                      <td>R${{getPreco(p)}}</td>
                      <td><img :src="p.url_imagem" class="url_imagem"></td>
                      <td>
                        <i :class="'fa fa-circle ativo_'+p.ativo" aria-hidden="true" title=""></i>
                      </td>
                      <td>
                        <div class="grupo_btn_acoes">
                          <router-link :to="{name: 'editarProduto', params: { id: p.id}}" class="btn_editar">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </router-link>
                          <i class="fa fa-trash-o btn_prod_excluir" aria-hidden="true" @click="excluir(p.id)"></i>
                        </div>
                      </td>
                    </tr>
                                          
                  </tbody>
                  <tfoot>
                  <tr>
                      <th v-for="coluna in colunas">
                          <a href="javascript:;" @click="orderProduto(coluna)">{{coluna | ucwords}}</a>
                      </th>
                  </tr>
                  </tfoot>
              </table>
              </div>
          </div>
        </div>
                <!-- /.box-body -->
      </div>
    </box>

      

    </section>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import Box from './Box' // importando box

export default {
  name: 'Produtos',
  components: {
    'box': Box
  },
  data () {
    return {
      products: [],
      order: {
        keys: '',
        sort: ''
      },
      colunas: ['id', 'nome', 'descricao', 'preco', 'imagem', 'ativo', ''],
      filter: '',
      categorias: [],
      cardapio: ''
    }
  },
  created () {
    this.getProducts()
    this.getCategorias()
  },
  methods: {
    novoProduto (id) {
      this.$store.commit('SET_ID_ALTERACAO', id)
      this.$router.push({name: 'Novo Produto'})
    },
    getProducts () {
      axios.get(`${this.$store.state.api}produtos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.products = response.data
      })
    },
    getCategorias() {
      axios.get(`${this.$store.state.api}categorias?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.categorias = response.data
      })
    },
    excluir (id) {
      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          axios.post(this.$store.state.api+'produtos/delete', {
            'id': id,
          }).then(response => {
            if(response.data.success) {
              this.getProducts()
              this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Produto Deletado',
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              this.$swal(
                'Ops!',
                'Não foi possivel deletar o produto.',
                'error'
              )
            }
          })
        } 
      })
    },
    orderProduto (coluna) {
      if (coluna === 'preco') {
        this.order.keys = 'Cardapios[0].tabela_preco.preco'
      } else {
        this.order.keys = coluna
      }
      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
    },
    filterCategoria(item) {
      if(!this.cardapio || this.cardapio === 'todos') return true
      if(item.Categorias) return item.Categorias.find((element) => { return element.id === this.cardapio }) ? true : false
      else return item.Cardapios.find((element) => { return element.id === this.cardapio }) ? true : false
    },
    getPreco(prod) {
      if(!this.cardapio || this.cardapio === 'todos') {
        if(prod.Categorias) {
          return prod.Categorias[0].tabela_preco.preco.toFixed(2)
        } else {
          return prod.Cardapios[0].tabela_preco ? prod.Cardapios[0].tabela_preco.preco.toFixed(2) : prod.Cardapios[0].tabela_precos.preco.toFixed(2)
        }
      } else {
        const ret = prod.Categorias ? prod.Categorias.filter(element => element.id == this.cardapio) : prod.Cardapios.filter(element => element.id == this.cardapio);
        return ret[0].tabela_preco ? ret[0].tabela_preco.preco.toFixed(2) : ret[0].tabela_precos.preco.toFixed(2)
      }
    }
  },
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    productsFiltered () {
      let colecao = _.orderBy(this.products, this.order.keys, this.order.sort)
      return _.filter(colecao, item => {
        return this.filterCategoria(item) && (item.nome.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0 || item.descricao.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)
      })
    },
  }
}
</script>
<style>
.url_imagem {
    width: 80px;
}
.grupo_btn_acoes {
  display: flex;
  font-size: 170%;
}
.btn_editar {
  margin-right: 10%;
  color: #333333
}
.btn_prod_excluir {
  margin-top: 1.5%;
}
.btn_editar:hover {
  color: #00C0EF!important;
  cursor:pointer;
}
.btn_prod_excluir:hover {
  color: #DD4B39;
  cursor:pointer;
}
.ativo_true {
  color: green
}
.ativo_false {
  color: #DD4B39
}
.padding{
  padding-top:10px;
  padding-right:10px
}
</style>



// WEBPACK FOOTER //
// Produtos.vue?39d8a3b2